import _ from 'lodash';
import { isSeasonalItem } from 'projectSpecific/sports/useHelpers/useSeasonals';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from '../../../../global/cnr/reducers/reducerHelpers/dispatchProps';
import { createRefPath_event } from '../../../../global/firestoreData/appData/appRefPaths';
import { backupData_district, updateFixedData_district, updateFixedData_teamAndMatches } from './reducerHelpers/sportsDataFix';
import { createSeasonalMatches, getDistrictData, getTeamsAndMatches, updateAllMatchesByLevel } from './reducerHelpers/sportsDistrictData';
import { sportsHelpers } from './reducerHelpers/sportsHelpers';

export const _district_glsCollections = {
  gls_access: 'gls_access',
  gls_district: 'gls_district',
  gls_teams: 'gls_teams',
}

export const _districtDashboardTypes = {
  menu: 'menu',
  matchesBySport: 'matchesBySport',
  schools: 'schools',
  sports: 'sports',
  teams_bySchool: 'teams_bySchool',
  teams_bySport: 'teams_bySport',
}

export const _districtDataIssueTypes = {
  menu: 'menu',
  badSectionMatches: 'badSectionMatches',
  matchTeamsNotFound: 'matchTeamsNotFound',
  mismatchedMatchData: 'mismatchedMatchData',
  modifiedMatchTeams: 'modifiedMatchTeams',
  missingTeamObjects: 'missingTeamObjects',
  schoolMerge: 'schoolMerge',
}

export const _districtCollections = {
  _districts: '_districts',
  _globals: '_globals',
  _gls_access: '_gls_access',
  _gls_district: '_gls_district',
  _gls_scores: '_gls_scores',
  _history: '_history',
  _matches_seasonal: '_matches_seasonal',
  _playoffs: '_playoffs',
  _rankings_seasonal: '_rankings_seasonal',
  _rosters: '_rosters',
  _schools: '_schools',
  _schools_district: '_schools_district',
  _scores_seasonal: '_scores_seasonal',
  _seasonals: '_seasonals',
  _sports: '_sports',
  _sportsAccess_district: '_sportsAccess_district',
  _sportsAccess_schools: '_sportsAccess_schools',
  _sportsAccess_sports: '_sportsAccess_sports',
  // _teams: '_teams',
  _teams_seasonal: '_teams_seasonal',
  _tournaments: '_tournaments',
  _tournaments_seasonal: '_tournaments_seasonal',
  _teamRosters: '_teamRosters',
  _teamStaff: '_teamStaff',
  // _teamRosters_seasonal: '_teamRosters_seasonal',
  athletes: 'athletes',
  districts: 'districts',
  globals: 'globals',
  history: 'history',
  organizations: 'organizations',
  schools: 'schools',
  schoolsByState: 'schoolsByState',
  sports: 'sports',
  teams: 'teams',
}

export const _useSportsKey = true

const _districtProjectPaths = {
  meSports: 'clients/b4C6wHP0A5AgQPTD78ue/events/pojoSports/',
  tsSports: 'clients/thumbstat/events/thumbstatSports/',
}

const rts = {
  handleAmmend_schoolsAccess: 'handleAmmend_schoolsAccess',
  handleAmmend_sportsAccess: 'handleAmmend_sportsAccess',
  handleBackup: 'handleBackup',
  handleCreate_seasonal: 'handleCreate_seasonal',
  handleCreate_teamInitials: 'handleCreate_teamInitials',
  handleFixData: 'handleFixData',
  handleFixTeamAndMatches: 'handleFixTeamAndMatches',
  handleGet_alternateTeamsAndMatches: 'handleGet_alternateTeamsAndMatches',
  // handleGet_currentUsers: 'handleGet_currentUsers',
  handleGet_districtData: 'handleGet_districtData',
  handleSet_currentUsers: 'handleSet_currentUsers',
  handleSet_dailyUsers: 'handleSet_dailyUsers',
  handleSet_dailyUsersU: 'handleSet_dailyUsersU',
  handleSet_districtData: 'handleSet_districtData',
  handleSet_districtSeasonalData: 'handleSet_districtSeasonalData',
  handleSet_districtSeasonalDataExisting: 'handleSet_districtSeasonalDataExisting',
  handleSet_sportSeasonData: 'handleSet_sportSeasonData',
  handleSet_sportSeasonMatches: 'handleSet_sportSeasonMatches',
  handleSet_sportsProps: 'handleSet_sportsProps',
  handleSplitMatchesByLevel: 'handleSplitMatchesByLevel',
  handleSet_districtInfo: 'handleSet_districtInfo',
  ...grts,
}

/**
 * 
 * @param {object} state 
 * @param {object} action 
 * @returns state
 * @description a sports season consists of multiple collections (teams, matches, rankings, history, scheduleDates, playoffs)
 * 
 */
export const sportsDistrictReducer = (state, action) => {

  const {
    _cacheData,
    database_fns,
    districtData,
    pathViews,
    sportsAccess_district,
  } = state

  const { type, dispatch, seasonalDataType: seasonalDataType_action } = action
  let _sportsAccess_district = sportsAccess_district

  const { cache_collections } = _cacheData ?? {}
  const { district_data: district_data_cache } = cache_collections ?? {}

  const sportsDistrict_handlers = sportsDistrictHandlers(dispatch)

  const { handleSet_districtData, handleSet_sportSeasonMatches } = sportsDistrict_handlers

  switch (type) {

    case rts.handleSet_districtInfo:
      const { districtInfo } = action
      if (districtInfo.schools && districtInfo.sports) {
        districtInfo.sportsTeams = getSportsTeamsFromSchools(districtInfo.sports, districtInfo.schools)
      }

      const accessAndSheets = {}

      if (districtInfo?.sportsAccess_sports?.data?.sportsAccess_sports) {
        accessAndSheets.sportsAccess_sports = districtInfo?.sportsAccess_sports?.data?.sportsAccess_sports
        delete accessAndSheets.sportsAccess_sports._itemKey
      }

      return { ...state, ...districtInfo, ...accessAndSheets, district_data: districtInfo, }

    case rts.handleSet_sportsProps:
      return { ...state, sports_all: action.sports_all, sportsKey: action.sportsKey, subCollection: action.subCollection }

    case rts.handleSet_currentUsers:

      let _currentUserCount = 0;
      let _lastItemCount = 0;

      const { currentUserCounts } = action

      if (currentUserCounts) {
        _.forEach(currentUserCounts, (value, index) => {
          _currentUserCount += _.sum(Object.values(value));
        })

        const [lastYearKey, lastYearValue] = _.last(_.toPairs(currentUserCounts));
        const [lastWeekKey, lastWeekValue] = _.chain(lastYearValue)
          .toPairs()
          .orderBy(([key]) => parseInt(key.replace('week', '')), 'asc') // sort numerically
          .last()
          .value();

        _lastItemCount = lastWeekValue
      }
      return { ...state, currentUserCounts: action.currentUserCounts, currentUserCount: _currentUserCount, lastItemCount: _lastItemCount }

    case rts.handleSet_dailyUsers:
      return { ...state, dailyCounts: action.dailyCounts }

    case rts.handleSet_dailyUsersU:
      return { ...state, dailyCountsU: action.dailyCountsU }

    case rts.handleSet_districtSeasonalDataExisting:
      return { ...state, seasonalDataType: action.seasonalDataType }

    case rts.handleSet_districtSeasonalData:
      const { isAlt } = action
      const _seasonalDatas = { ...state.seasonalDatas }
      const _nonSeasonalDatas = { ...state.nonSeasonalDatas }
      const isSeasonal = isSeasonalItem(seasonalDataType_action)
      if (isSeasonal) {
        const syd = getSeasonSportYearsData(action.seasonalData, state.sportsKey, state.sports)
        _seasonalDatas[seasonalDataType_action] = syd
        if (isAlt) {
          return { ...state, seasonalDatas_alt: _seasonalDatas }
        } else {
          return { ...state, seasonalDatas: _seasonalDatas }
        }
      } else {
        const syddd = getSeasonSportData(action.seasonalData, state.sportsKey, state.sports)
        console.log('syddd', syddd)
        _nonSeasonalDatas[seasonalDataType_action] = syddd //action.seasonalData
        if (isAlt) {
          return { ...state, nonSeasonalDatas_alt: _nonSeasonalDatas }
        } else {
          return { ...state, nonSeasonalDatas: _nonSeasonalDatas }
        }
      }

    case rts.handleSet_sportSeasonData:
      const { seasonalDataType, subCollection } = state
      const { _itemKey } = action.sportSeasonData ?? {}
      const _refPath = subCollection ? createRefPath_event(pathViews, [seasonalDataType, _itemKey, subCollection]) : createRefPath_event(pathViews, [seasonalDataType, _itemKey])
      database_fns.get_data({ refPath: _refPath, callback: handleSet_sportSeasonMatches })
      return { ...state, sportSeasonData: action.sportSeasonData }

    case rts.handleSet_sportSeasonMatches:
      return { ...state, sportSeasonMatches: action.sportSeasonMatches, updating: false }

    case rts.handleGet_districtData:
      getDistrictData(database_fns, pathViews, handleSet_districtData)
      return state

    case rts.handleSet_districtData:
      return { ...state, districtData: action.data }

    case rts.handleBackup:
      backupData_district(pathViews, action, districtData)
      return state

    case rts.handleFixData:
      updateFixedData_district(pathViews, action, districtData)
      return state

    case rts.handleFixTeamAndMatches:
      updateFixedData_teamAndMatches(pathViews, districtData)
      return state

    case rts.handleSplitMatchesByLevel:
      const cb = (r) => {
        console.log('r', r)
      }
      updateAllMatchesByLevel(pathViews, districtData, cb)
      return state

    case rts.handleCreate_teamInitials:
      const _nsd = _.cloneDeep(state.nonSeasonalDatas)
      createTeamInitials(_nsd, state)
      return { ...state, nonSeasonalDatas: _nsd }

    case rts.handleCreate_seasonal:
      const cbs = (r) => {
        console.log('r', r)
      }
      createSeasonalMatches(database_fns, pathViews, districtData, cbs)
      return state

    case rts.handleAmmend_schoolsAccess:
      if (!_sportsAccess_district) { _sportsAccess_district = {} }
      if (!_sportsAccess_district.schools) { _sportsAccess_district.schools = {} }
      const { access_schools } = action ?? {}
      if (access_schools) { _sportsAccess_district.schools = access_schools }
      return { ...state, sportsAccess_district: _sportsAccess_district, updating: false }

    case rts.handleAmmend_sportsAccess:
      if (!_sportsAccess_district) { _sportsAccess_district = {} }
      if (!_sportsAccess_district.sports) { _sportsAccess_district.sports = {} }
      const { access_sports } = action ?? {}
      if (access_sports) { _sportsAccess_district.sports = access_sports }
      return { ...state, sportsAccess_district: _sportsAccess_district, updating: false }

    case rts.handleGet_alternateTeamsAndMatches:
      const x = getTeamsAndMatches(action.mergeItems, districtData)
      const _districtData = { ...districtData }
      _districtData.mergeData = x
      return { ...state, districtData: _districtData }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation }, { gsMatchedRefreshed: false })

    default:
      return state
  }
}

export const sportsDistrictHandlers = (dispatch) => {
  return {
    handleAmmend_schoolsAccess: (access_schools) => { dispatch({ type: rts.handleAmmend_schoolsAccess, dispatch, access_schools }) },
    handleAmmend_sportsAccess: (access_sports) => { dispatch({ type: rts.handleAmmend_sportsAccess, dispatch, access_sports }) },
    handleBackup: (currentItemKey, selectedSport, selectedYear, forPlayoff) => { dispatch({ type: rts.handleBackup, dispatch, currentItemKey, selectedSport, selectedYear, forPlayoff }) },
    handleCreate_seasonal: () => { dispatch({ type: rts.handleCreate_seasonal, dispatch }) },
    handleCreate_teamInitials: () => { dispatch({ type: rts.handleCreate_teamInitials, dispatch }) },
    handleFixData: (currentItemKey) => { dispatch({ type: rts.handleFixData, dispatch, currentItemKey }) },
    handleFixTeamAndMatches: () => { dispatch({ type: rts.handleFixTeamAndMatches, dispatch }) },
    handleGet_alternateTeamsAndMatches: (mergeItems) => { dispatch({ type: rts.handleGet_alternateTeamsAndMatches, mergeItems }) },
    // handleGet_currentUsers: () => { dispatch({ type: rts.handleGet_currentUsers, dispatch }) },
    handleGet_districtData: () => { dispatch({ type: rts.handleGet_districtData, dispatch }) },
    handleSet_dailyUsers: (dailyCounts) => { dispatch({ type: rts.handleSet_dailyUsers, dispatch, dailyCounts }) },
    handleSet_dailyUsersU: (dailyCountsU) => { dispatch({ type: rts.handleSet_dailyUsersU, dispatch, dailyCountsU }) },
    handleSet_currentUsers: (currentUserCounts) => { dispatch({ type: rts.handleSet_currentUsers, dispatch, currentUserCounts }) },
    handleSet_districtData: (data) => { dispatch({ type: rts.handleSet_districtData, dispatch, data }) },
    handleSet_districtSeasonalData: (seasonalData, seasonalDataType, isAlt) => { dispatch({ type: rts.handleSet_districtSeasonalData, dispatch, seasonalData, seasonalDataType, isAlt }) },
    handleSet_districtSeasonalDataExisting: (seasonalDataType) => { dispatch({ type: rts.handleSet_districtSeasonalDataExisting, dispatch, seasonalDataType }) },
    handleSet_sportSeasonData: (sportSeasonData) => { dispatch({ type: rts.handleSet_sportSeasonData, dispatch, sportSeasonData }) },
    handleSet_sportSeasonMatches: (sportSeasonMatches) => { dispatch({ type: rts.handleSet_sportSeasonMatches, dispatch, sportSeasonMatches }) },
    handleSet_sportsProps: (sports_all, sportsKey, subCollection) => { dispatch({ type: rts.handleSet_sportsProps, dispatch, sports_all, sportsKey, subCollection }) },
    handleSplitMatchesByLevel: () => { dispatch({ type: rts.handleSplitMatchesByLevel, dispatch }) },
    handleSet_districtInfo: (districtInfo) => { dispatch({ type: rts.handleSet_districtInfo, dispatch, districtInfo }) },
    ...responseHandlers(dispatch),
  }
}

export const sportsDistrictInitialState = (init_state) => {
  return { ...init_state, currents: {}, currentSidebars: {}, seasonalDatas: {}, nonSeasonalDatas: {} }
};

const ammendDistrictAccess = (dataPure) => {

  const { gls_access, gls_district, gls_scores, sportsAccess_sports, sportsAccess_district, sportsAccess_schools } = dataPure ?? {}
  const { schools: schools_district, sports } = sportsAccess_district ?? {}
  const { schools: schools_schools } = sportsAccess_schools ?? {}

  const gls = {
    access: gls_access,
    district: gls_district,
    scores: gls_scores,
  }

  const access = {
    district: {
      bySchool: schools_district,
      bySport: sports,
    },
    schools: {
      ...schools_schools,
    }
  }

  return { gls, access }
}


// const extractDataFromObject = (data, exclusions) => _.omit(data, exclusions);

const getSeasonSportYearsData = (seasonalData, sportsKey, sports) => {
  let _sportsSeasons = null
  const seasonItems = _.groupBy(seasonalData, 'parentKeys.sports');
  if (seasonItems) {
    _.forEach(seasonItems, (seasonItem, sportKey) => {
      if (seasonItem) {
        _.forEach(seasonItem, (seasonalItem) => {
          const { parentKeys, _itemKey } = seasonalItem ?? {}
          const { sports: sports_pks, sportsYears: sportsYears_pks } = parentKeys ?? {}
          let allow = true
          if (sportsKey) {
            if (sportsKey !== sports_pks) {
              allow = false
            }
          }
          if (allow) {
            const _sport = sports ? sports[sports_pks] : {}
            const { name } = _sport ?? {}
            if (!_sportsSeasons) { _sportsSeasons = {} }
            if (!_sportsSeasons[name]) { _sportsSeasons[name] = {} }
            if (!_sportsSeasons[name][sportsYears_pks]) { _sportsSeasons[name][sportsYears_pks] = {} }
            _sportsSeasons[name][sportsYears_pks] = {
              sport: name,
              year: sportsYears_pks,
              _itemKey,
              _itemData: seasonalItem
            }
          }
        })
      }
    })
  }
  return _sportsSeasons
}

const getSeasonSportData = (seasonalData, sportsKey, sports) => {
  let _sportsSeasons = null
  const seasonItems = _.groupBy(seasonalData, 'parentKeys.sports');
  if (seasonItems) {
    _.forEach(seasonItems, (seasonItem, sportKey) => {
      if (seasonItem) {
        _.forEach(seasonItem, (seasonalItem) => {
          const { parentKeys, _itemKey } = seasonalItem ?? {}
          const { sports: sports_pks } = parentKeys ?? {}
          let allow = true
          if (sportsKey) {
            if (sportsKey !== sports_pks) {
              allow = false
            }
          }
          if (allow) {
            const _sport = sports ? sports[sports_pks] : {}
            const { name } = _sport ?? {}
            if (!_sportsSeasons) { _sportsSeasons = {} }
            if (!_sportsSeasons[name]) { _sportsSeasons[name] = {} }
            _sportsSeasons[name] = {
              sport: name,
              _itemKey,
              _itemData: seasonalItem
            }
          }
        })
      }
    })
  }
  return _sportsSeasons
}


const getSeasonSportTeamsYearsData = (seasonalData, sportsKey, sports, parentKeyType) => {
  const ts = {}
  let _sportsSeasons = null
  const seasonItems = _.groupBy(seasonalData, 'parentKeys.years');
  if (seasonItems) {
    _.forEach(seasonItems, (seasonItem, sportKey) => {
      if (seasonItem) {
        const teamItems = _.groupBy(seasonItem, 'parentKeys.teams');
        _.forEach(teamItems, (teamItem) => {
          _.forEach(teamItem, (team_item) => {
            const { parentKeys, _itemKey, athletes } = team_item ?? {}
            const { sports: sports_pks, sportsYears: sportsYears_pks, teams: teams_pks } = parentKeys ?? {}
            if (!ts[sports_pks]) { ts[sports_pks] = {} }
            if (!ts[sports_pks][teams_pks]) { ts[sports_pks][teams_pks] = {} }
            if (!ts[sports_pks][teams_pks][sportsYears_pks]) { ts[sports_pks][teams_pks][sportsYears_pks] = {} }
            ts[sports_pks][teams_pks][sportsYears_pks].athletes = athletes
          })


        })
      }
    })
  }
  return _sportsSeasons
}

const getSportsTeamsFromSchools = (sports_district, schoolsWithTeams) => {
  const sportsTeams = {}
  // loop the sports in the district
  _.forEach(sports_district, (sport, sportKey) => {
    sportsTeams[sportKey] = { name: sport.name, teams: {} }
    // get the school that have teams
    const _sportSchools = _.filter(schoolsWithTeams, (school) => _.has(school.teams, sportKey))
    _.forEach(_sportSchools, (sportSchool) => {
      const { _itemKey: schoolKey, initials, teams } = sportSchool
      const _team = teams ? teams[sportKey] : {}
      if (_team) {
        const { teamKey } = _team
        switch (schoolKey) {
          case '_itemKey':
            break;
          default:
            sportsTeams[sportKey].teams[teamKey] = {
              name: sportSchool.name,
              initials: initials,
              schoolKey: schoolKey,
              _itemKey: teamKey
            }
        }
      }
    })
  })
  return sportsTeams
}

const createTeamInitials = (nonSeasonalDatas, state) => {

  const { pathViews, sports: sports_district, schools: schools_district } = state

  const pks = {
    organizations: pathViews.organizations,
    districts: pathViews.districts
  }

  const { teams, schools } = nonSeasonalDatas
  const schoolsWithTeams = _.cloneDeep(schools_district)

  const _teams = _.cloneDeep(teams)

  const allSchools = {
    existing: [],
    nonExisting: []
  }

  if (_teams) {

    const _allTeams = {}

    const _sportTeams = _.groupBy(_teams, 'parentKeys.sports')

    _.forEach(_sportTeams, (sp) => {
      _.forEach(sp, (t) => {
        const { name } = t
        if (!_allTeams[name]) {
          _allTeams[name] = { name: t.name }
          const _school = _.find(schools_district, { name: t.name })
          if (_school) {
            allSchools.existing.push(t)
          } else {
            allSchools.nonExisting.push(t)
          }
        }
      })
    })

    sportsHelpers.createTeamInitials(_allTeams)

    const _keys = ["_itemKey", "id"]

    _.forEach(_sportTeams, (sp) => {
      _.forEach(sp, (t) => {
        const { name } = t
        if (_allTeams[name] && _allTeams[name].initials) {
          t.initials = _allTeams[name].initials
          // _.forEach(_keys, (key) => {
          //   delete t[key]
          // })
        }
      })
    })

    const inits = []
    _.forEach(_sportTeams, (ts) => {
      _.forEach(ts, (t) => {
        const { initials, name } = t
        if (!inits[initials]) { inits[initials] = [] }
        if (!inits[initials].includes(name)) {
          inits[initials].push(name)
        }
      })
    })
  }

  // Iterate over all teams (_teams object) using Lodash's forEach function
  _.forEach(_teams, (team, teamKey) => {
    // Destructure the team object to extract parentKeys and initials
    const { parentKeys, initials } = team;

    // Destructure parentKeys to extract schools and sports primary keys
    const { schools: schools_pks, sports: sports_pks } = parentKeys;

    // Retrieve the sport details from the sports_district object using the sports primary key
    const _sport = sports_district && sports_district[sports_pks];

    // Check if the school (referenced by schools_pks) exists in schoolsWithTeams
    if (schoolsWithTeams && schoolsWithTeams[schools_pks]) {
      // Assign the initials from the team to the corresponding school entry
      schoolsWithTeams[schools_pks].initials = initials;

      // If the school doesn't already have a "teams" property, initialize it as an empty object
      if (!schoolsWithTeams[schools_pks].teams) {
        schoolsWithTeams[schools_pks].teams = {};
      }

      // Add the team details to the "teams" map for the schoolf
      schoolsWithTeams[schools_pks].teams[sports_pks] = {
        teamKey,           // Unique identifier for the team
        sport: _sport.name, // The name of the sport associated with the team
        active: true        // Mark the team as active
      };
    }
  });

  const _schoolsWithTeams = _.pickBy(schoolsWithTeams, school => _.has(school, 'teams'));

  _.forEach(_schoolsWithTeams, (schoolItem, swkKey) => {
    const { teams } = schoolItem
    if (teams) {
      _.forEach(sports_district, (sport_district, sportKey) => {
        switch (sportKey) {
          case '_itemKey':
            break;
          default:
            if (!teams[sportKey]) {
              teams[sportKey] = {
                teamKey: database_fns.get_docKey(),
                sport: sport_district.name,
                active: false
              }
            }
        }

      })
    }

  })

  const _schools_district = {
    parentKeys: pks,
    schools: {
      ..._schoolsWithTeams
    }
  }

  if (!state._dataUpdates) { state._dataUpdates = {} }
  state._dataUpdates._schools_district = _schools_district
  nonSeasonalDatas.teams = _teams

} 